// Copyright (c) 2022 by Move Closer

import { ComputedRef, Ref } from '@vue/composition-api'

import { CanBeDisabled } from '../../../composables'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface UseDropdownItemProvides {
  /**
   * Determines the loading state of the item. (if its async)
   */
  isLoading: Ref<boolean>

  /**
   * Determines the `element` for item.
   */
  tag: ComputedRef<string>

  /**
   * Handles the click event of the item.
   */
  _onClick: () => void
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface DropdownItemProps extends Partial<CanBeDisabled> {
  /**
   * Determines the icon for current element.
   */
  icon?: string

  /**
   * Determines the label for current element.
   */
  label?: string

  /**
   * Determines function call for `onclick` of current element.
   */
  onClick?: () => void | Promise<any>

  /**
   * Determines the type of the element.
   *
   * @see DropdownItemType
   */
  type: string
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export enum DropdownItemType {
  Divider = 'diver',
  Item = 'item'
}
